<div class="d-flex">
  <div>
    <div class="strong">
      Afmetingen RAAM
    </div>
    <div class="small-upper-space d-flex">
      <div>
        <div>Hoogte (in cm)</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Hoogte in cm"
            type="number"
            [(ngModel)]="stickerPart.windowHeight"
          />
        </mat-form-field>
      </div>
      <div class="small-left-space">
        <div>Breedte (in cm)</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Breedte in cm"
            type="number"
            [(ngModel)]="stickerPart.windowWidth"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="left-space equal-button">
    <button
      mat-button
      class="button align-button"
      type="button"
      (click)="fillStickerSizes()"
    >
      =
    </button>
  </div>
  <div class="left-space">
    <div class="strong">
      Afmetingen STICKER
    </div>
    <div class="small-upper-space d-flex">
      <div>
        <div>Hoogte (in cm)</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Hoogte in cm"
            type="number"
            [(ngModel)]="stickerPart.stickerHeight"
          />
        </mat-form-field>
      </div>
      <div class="small-left-space">
        <div>Breedte (in cm)</div>
        <mat-form-field appearance="outline">
          <input
            matInput
            placeholder="Breedte in cm"
            type="number"
            [(ngModel)]="stickerPart.stickerWidth"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div class="small-upper-space">
  <textarea-input
    [initContent]="stickerPart.description"
    [placeholder]="'Extra info'"
    [client]="true"
    (answer)="descriptionChanged($event)"
  ></textarea-input>
</div>
